<div class="heading">
	<ng-container [ngSwitch]="headingSize">
		<h5 *ngSwitchCase="'h5'" class="text-primary">{{ heading }}</h5>
		<h6 *ngSwitchCase="'h6'" class="text-primary">{{ heading }}</h6>
		<ng-container *ngSwitchDefault></ng-container>
	</ng-container>
	<ng-container *ngIf="infoPopOver">
		<app-popover [popover]="infoPopOver"></app-popover>
	</ng-container>
</div>
